<template>
  <div class="container-calendar-client position-relative">
    <div
      id="calendar-view-client"
      class="d-flex flex-row justify-content-start align-items-start"
    >
      <div class="side-bar-content h-100 p-1">
        <div class="filter-container-inner">
          <div class="form">
            <month-picker
              :defaultMonth="selectedMonth"
              :defaultYear="selectedYear"
              @change="
                newDate => {
                  date = newDate;
                }
              "
            />
          </div>
          <hr class="divider" />
          <div class="sidebar-filters-container">
            <div class="mx-3">
              <b-form-group label="">
                <div>
                  <b-form-checkbox-group
                    v-model="filter.types"
                    name="event-type"
                  >
                    <div class="event-type-item">
                      <div class="event-type-label">
                        <span style="width:30px">
                          <i class="fa fa-file-alt"></i>
                        </span>
                        <label class="event-type-label-item">Documents</label>
                      </div>
                      <b-form-checkbox :value="'documents'"> </b-form-checkbox>
                    </div>
                    <div class="event-type-item">
                      <div class="event-type-label">
                        <span style="width:30px">
                          <i class="fa fa-users"></i>
                        </span>
                        <label class="event-type-label-item"
                          >Group Sessions</label
                        >
                      </div>
                      <b-form-checkbox :value="'groupSessions'">
                      </b-form-checkbox>
                    </div>
                    <div class="event-type-item">
                      <div class="event-type-label">
                        <span style="width:30px">
                          <i class="fa fa-user"></i>
                        </span>
                        <label class="event-type-label-item"
                          >Appointments</label
                        >
                      </div>
                      <b-form-checkbox :value="'appointments'">
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </div>
              </b-form-group>
            </div>
            <hr class="divider" />
            <div class="mx-3">
              <div style="font-size: 12px; margin-bottom: 10px">
                Remaining approved units:
              </div>
              <div>
                <div
                  v-for="(ur, urIndex) in ursRemaining"
                  :key="ur.id"
                  class="border border-med-light-gray mb-2 p-2"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="d-flex align-items-center">
                      <h3 class="text-primary mb-0 mr-2 text-nowrap">
                        {{ ur.remainingUnits }}
                      </h3>
                      <div class="cut-text">
                        {{ ur.service.name }}
                      </div>
                    </div>
                    <b-dropdown
                      size="sm"
                      html="<span style='font-size:12px;'>Assign</span>"
                      no-caret
                      class=""
                      ref="autoFillDropdown"
                      boundary="window"
                      dropright
                      toggle-tag="a"
                      toggle-class="text-primary"
                      variant="none"
                      @show="
                        showAutoFill = { ...showAutoFill, [urIndex]: true }
                      "
                      @hide="
                        showAutoFill = { ...showAutoFill, [urIndex]: false }
                      "
                      offset="-150"
                    >
                      <b-dropdown-form>
                        <utilization-auto-fill-dropdown-content
                          v-if="showAutoFill[urIndex]"
                          :numberOfUnits="ur.remainingUnits"
                          :startDate="ur.startDate"
                          :endDate="ur.endDate"
                          :restrictDates="true"
                          @autoFill="
                            dates => autoFill(ur.service.id, dates, urIndex)
                          "
                        />
                      </b-dropdown-form>
                    </b-dropdown>
                  </div>
                  <div style="font-size:10px;">
                    ({{ formatDateOnly(ur.startDate) }}-{{
                      formatDateOnly(ur.endDate)
                    }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" style="width:210px">
          <b-button
            class="smaller-button action-button"
            variant="outline-primary"
            @click="addPlaceClient"
            size="sm"
            >Place Patient in Groups</b-button
          >
        </div>
      </div>
      <div class="calendar-content w-100">
        <calendar
          class="h-100"
          ref="calendar"
          :date="calendarDate"
          :tbar="tbar"
          :modes="modes"
          :events="calendarEvents"
          :resources="calendarResources"
          :sidebar="false"
          :listeners="listeners"
          :eventMenuFeature="eventMenuFeature"
          :eventTooltipFeature="eventTooltipFeature"
          :dragFeature="false"
        ></calendar>
      </div>
    </div>

    <appointment-add-edit-modal
      v-if="showAddEditAppointment"
      v-model="showAddEditAppointment"
      :scheduleEventId="editAppointmentId"
      @onModify="onModifyAddEditAppointment"
      @onHidden="
        () => {
          showAddEditAppointment = false;
          fetchData();
        }
      "
    />

    <billing-document-invoice-view-modal
      v-model="invoiceViewModal.show"
      :id="invoiceViewModal.id"
      :showing="invoiceViewModal.show"
      @close="
        () => {
          invoiceViewModal.show = false;
          invoiceViewModal.id = null;
          this.fetchScheduleEvents();
        }
      "
      @edit="
        data => {
          invoiceViewModal.show = false;
          newInvoiceModal.id = data;
          newInvoiceModal.show = true;
        }
      "
      @payment="
        invoiceData => {
          invoiceViewModal.show = false;
          showInvoicePaymentModal(invoiceData);
        }
      "
    />

    <billing-document-invoice-add-edit-modal
      :id="newInvoiceModal.id"
      v-if="newInvoiceModal.show"
      v-model="newInvoiceModal.show"
      :showing="newInvoiceModal.show"
      :episodeOfCareId="newInvoiceModal.episodeOfCareId"
      :encounterIds="newInvoiceModal.encounterIds"
      @close="
        () => {
          newInvoiceModal.show = false;
          newInvoiceModal.id = null;
          this.fetchScheduleEvents();
        }
      "
    />

    <group-session-add-edit-modal
      v-if="showAddEditGroup"
      v-model="showAddEditGroup"
      @onModify="onModifyAddEditGroup"
      :groupId="editGroupId"
    />
    <group-session-participant-notes-add-edit-modal
      v-if="participantNotesEditor.show"
      v-model="participantNotesEditor.show"
      :scheduleEvent="participantNotesEditor.scheduleEvent"
      :participant="participantNotesEditor.participant"
      @onModify="onModifyGroupNotes"
      @onHidden="onHiddenGroupNotes"
    />
    <document-add-edit-modal
      v-if="showAddDocumentEditor"
      v-model="showAddDocumentEditor"
      :formId="editDocument.formId"
      @onModify="onModifyAddDocument"
      :clientId="editDocument.clientId"
      :eocId="editDocument.eocId"
      :submitId="editDocument.submitId"
      :hasAppointmentRelated="hasAppointmentRelated"
      :scheduleEventId="editDocument.scheduleEventId"
      :scheduleEventParticipantId="editDocument.scheduleEventParticipantId"
    />
    <document-file-add-edit-modal
      v-if="showAddFileDocumentEditor"
      v-model="showAddFileDocumentEditor"
      :eocId="editFileDocument.eocId"
      :formId="editFileDocument.formId"
      :clientId="editFileDocument.clientId"
      :scheduleEventId="editFileDocument.scheduleEventId"
      :submitId.sync="editFileDocument.submitId"
      @onModify="onModifyFileAddEditDocument"
      :attachForm="true"
    />
    <document-view-modal
      v-if="documentViewModal.show"
      v-model="documentViewModal.show"
      :documentId="documentViewModal.id"
      @onModify="onModifydocumentViewer"
    />
    <eoc-view-calendar-place-in-groups-modal
      v-if="showAddPlaceClientEditor"
      v-model="showAddPlaceClientEditor"
      @onModify="onModifyAddPlaceClient"
      :eocId="eocId"
    />
    <eoc-view-calendar-utilization-autofill-modal
      v-if="showAddAutofill"
      v-model="showAddAutofill"
      @onModify="onModifyAddAutofill"
      :eocId="eocId"
      :urId="autofillUrId"
    />

    <payment-add-edit-modal
      :transactionType="'Payment'"
      :formTitle="`Add payment for ${paymentAddModal.patient.name}`"
      v-if="paymentAddModal.show"
      v-model="paymentAddModal.show"
      :patientId="paymentAddModal.patient.patientId"
      :invoiceId="paymentAddModal.invoiceId"
      @onHidden="
        () => {
          paymentAddModal.show = false;
          fetchScheduleEvents();
        }
      "
      @success="
        () => {
          paymentAddModal.show = false;
          fetchScheduleEvents();
        }
      "
    />

    <b-modal
      centered
      no-close-on-backdrop
      title="Attach new document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="attachForm"
      v-model="showSubmitForm"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()"> Close</b-button>
        <b-button variant="primary" v-if="selectedForm != null" @click="ok()">
          Attach
        </b-button>
        <b-button variant="primary" v-else disabled> Attach</b-button>
      </template>
      <b-form-group label="Document type:">
        <v-select v-model="selectedForm" :options="formOptions"></v-select>
      </b-form-group>
      <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-group-2"
          v-model="selectedDocType"
          :aria-describedby="ariaDescribedby"
          name="radio-sub-component"
        >
          <b-form-radio class="mr-5" value="standard"
            >Standard Document
          </b-form-radio>
          <b-form-radio value="upload">Document Upload</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-modal>
    <b-modal
      centered
      no-close-on-backdrop
      title="Attach existing document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="attachDocument"
      v-model="showSubmitDocument"
      header-class="bg-purple"
      dialog-class="modal-attach-doc"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()"> Close</b-button>
        <b-button
          variant="primary"
          v-if="selectedDocuments.length != 0"
          @click="ok()"
        >
          Attach
        </b-button>
        <b-button variant="primary" v-else disabled> Attach</b-button>
      </template>
      <div class="more-info mb-2">
        <span class="b-inline">Select documents to attach:</span>
        <span class="b-inline pull-right"
          >{{ selectedDocuments.length }} documents selected
          <a
            class="btn-link"
            @click="cleanSelectedDocuments"
            style="cursor: pointer"
            >Clear</a
          ></span
        >
      </div>
      <b-form-input
        v-model="docSearch"
        placeholder="Search by Ref# or Document type..."
        @input="fetchDocsByEOC(docSearch, 0)"
      ></b-form-input>
      <document-picker
        ref="documentPicker"
        :docs="documentsByEoc"
        v-model="selectedDocumentsComputed"
        :isLastPage="attachDocPagination.lastPage"
        @loadMore="
          fetchDocsByEOC(docSearch, attachDocPagination.page + 1, true)
        "
      />
    </b-modal>

    <div
      v-if="!showEocCares"
      class="d-flex justify-content-between align-items-center bg-med-light-gray text-white text-vertical px-2 py-3 show-eoc-cares"
    >
      <i
        @click="showEocCares = true"
        class="fa fa-chevron-circle-left hover-pointer mb-2"
        style="font-size: 14px"
      ></i>
      <div style="transform: rotate(180deg);">Utilization</div>
    </div>
    <div class="eoc-cares">
      <div
        class="bg-white eoc-cares-list"
        :class="showEocCares ? 'eoc-cares-list-show' : ''"
      >
        <div style="width: 250px;">
          <div
            @click="showEocCares = false"
            class="d-flex justify-content-between align-items-center bg-med-light-gray text-white p-2"
          >
            <span>Assigned Days</span>
            <i
              @click="showEocCares = false"
              class="fa fa-chevron-circle-right hover-pointer"
            ></i>
          </div>
          <div class="p-2">
            <div
              class="mt-2 p-2"
              v-for="eocCareItem in eocCaresList"
              :key="eocCareItem.loc.id"
            >
              <span :style="'color:' + eocCareItem.loc.color">{{
                eocCareItem.loc.name
              }}</span>
              <div class="d-flex flex-wrap w-100">
                <div
                  class="d-flex align-items-center"
                  v-for="date in eocCareItem.dates"
                  :key="date.date"
                  style="width: 50%"
                >
                  <span>{{ date.date }}</span>
                  <img
                    :src="imageDelete"
                    width="17"
                    height="17"
                    class="pb-1 pl-1 hover-pointer"
                    @click="deleteEocCare(date.eocCareId)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";
import Calendar from "../../third_party/calendar/Calendar.vue";
import urRecordServer from "../../server/urRecord";
import documentServer from "../../server/document";
import formSubmitterServer from "../../server/formSubmitter";
import scheduleEventServer from "../../server/scheduleEvent";
import diagnosisCodeServer from "../../server/diagnosisCode";
import {
  formatStartDateSql,
  formatEndDateSql,
  formatDate,
  formatDateOnlyMysql,
  calculateDurationInMinutes,
  getWeekDay,
  formatTimeOnly
} from "../../helpers/date";
import {
  addClass,
  hasClass,
  on,
  removeClass,
  waitForElm
} from "../../helpers/layout";
import { lightenDarkenColor } from "../../helpers/general";
import DocumentAddEditModal from "./document/DocumentAddEditModal.vue";
import DocumentFileAddEditModal from "./document/DocumentFileAddEditModal.vue";
import EocViewCalendarUtilizationAutofillModal from "./EocViewCalendarUtilizationAutofillModal";
import GroupSessionAddEditModal from "../group_session/GroupSessionAddEditModal.vue";
import GroupSessionParticipantNotesAddEditModal from "../group_session/GroupSessionParticipantNotesAddEditModal.vue";
import AppointmentAddEditModal from "../scheduler/AppointmentAddEditModal.vue";
import EocViewCalendarPlaceInGroupsModal from "./EocViewCalendarPlaceInGroupsModal";
import MonthPicker from "../controls/MonthPicker";
import UtilizationAutoFillDropdownContent from "../utilization/UtilizationAutoFillDropdownContent.vue";
import { getFormBuilderComponents } from "../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import BillingDocumentInvoiceAddEditModal from "../billing/billing_document/BillingDocumentInvoiceAddEditModal.vue";
import BillingDocumentInvoiceViewModal from "../billing/billing_document/BillingDocumentInvoiceViewModal.vue";
import DocumentPicker from "../controls/DocumentPicker";
import DocumentViewModal from "../episode_of_care/document/DocumentViewModal.vue";
import PaymentAddEditModal from "../billing/billing_transactions/PaymentAddEditModal.vue";

export default {
  name: "EocViewCalendar",
  components: {
    Calendar,
    GroupSessionAddEditModal,
    GroupSessionParticipantNotesAddEditModal,
    DocumentAddEditModal,
    MonthPicker,
    EocViewCalendarPlaceInGroupsModal,
    EocViewCalendarUtilizationAutofillModal,
    UtilizationAutoFillDropdownContent,
    AppointmentAddEditModal,
    BillingDocumentInvoiceViewModal,
    BillingDocumentInvoiceAddEditModal,
    DocumentFileAddEditModal,
    DocumentPicker,
    DocumentViewModal,
    PaymentAddEditModal
  },
  props: ["showing", "eocId", "location"],
  data() {
    return {
      showAutoFill: {},
      allEvents: [],
      scheduleEvents: [],
      appointments: [],
      documentsList: [],
      showSubmitForm: false,
      showSubmitDocument: false,
      selectedForm: null,
      selectedDocuments: [],
      docSearch: null,
      documentsByEoc: [],
      selectedDocType: "standard",
      tbar: {
        items: {
          todayButton: false,
          prevButton: false,
          nextButton: false
        }
      },
      filter: {
        startDate: formatDateOnlyMysql(),
        endDate: formatDateOnlyMysql(),
        types: ["groupSessions", "documents", "appointments"]
      },
      attachDocPagination: {
        pageSize: 10,
        page: 0,
        count: 0,
        lastPage: false
      },
      invoiceViewModal: {
        show: false,
        id: null
      },
      documentViewModal: {
        show: false,
        id: null
      },
      newInvoiceModal: {
        show: false,
        id: null,
        episodeOfCareId: null,
        encounterIds: []
      },
      participantNotesEditor: {
        show: false,
        scheduleEvent: null,
        participant: null
      },
      documentEditor: {
        show: false,
        formId: null,
        clientId: null,
        eocId: null,
        submitId: null,
        effectiveDateTime: null,
        scheduleEventId: null,
        scheduleEventParticipantId: null
      },
      paymentAddModal: {
        show: false,
        patient: null,
        invoiceId: null
      },
      schduleEvent: null,
      selectedMonth: 0,
      selectedYear: 0,
      date: formatDateOnlyMysql(),
      listeners: {
        beforeEventEdit: this.beforeEventEdit,
        beforeEventDelete: this.beforeEventDelete,
        dayNumberClick: this.setDate,
        weekNumberClick: this.setDate,
        dateRangeChange: this.dateRangeChange,
        activeItemChange: this.activeItemChange,
        eventClick: this.eventClick,
        paint: this.paint
      },
      editParticipantDocuments: {
        scheduleEvent: null,
        participant: null
      },
      eventMenuFeature: {
        disabled: true
      },
      eventTooltipFeature: {
        showOn: "click",
        onShow: async e => {
          const scheduleEventId =
            e.source._eventRecord?.originalData.eventData?.id;
          const el = document.getElementById(e.source.id);
          await waitForElm(".schedule-event-tooltip-data");

          const selects = el.querySelectorAll("select.status-select");
          if (selects && selects.length) {
            selects.forEach(select => {
              const dataId = select.getAttribute("data-id");
              const status = this.allEvents.flatMap(x =>
                x.episodesOfCare.filter(y => y.id == dataId)
              )[0].scheduleEventStatus;

              const color = status.color;
              const bgColor = lightenDarkenColor(color, 85);
              select.value = status.id;
              select.style.color = color;
              select.style.backgroundColor = bgColor;

              select.onfocus = () => {
                this.oldStatusId = select.value;
              };
              select.onchange = async e => {
                const participantId = select.dataset.id;
                const statusId = e.target.value;
                const status = this.statuses.find(u => u.value == statusId)
                  .data;
                select.style.color = status.color;
                select.style.backgroundColor = status.backgroundColor;
                await scheduleEventServer.setStatus(participantId, {
                  statusId
                });
                const oldStatusId = this.oldStatusId;

                const element = document.getElementById("billing");
                const billingInfo = await scheduleEventServer.getCostVariations(
                  participantId,
                  { statusId, oldStatusId }
                );
                if (
                  this.hasCurrentUserPermissionAccess(
                    "others",
                    "patientBillingInfo"
                  ) &&
                  billingInfo
                ) {
                  if (element) element.style.display = "block";

                  document.getElementById(
                    "totalAmount"
                  ).innerHTML = `Fee: ${this.toCurrencyValue(
                    billingInfo.totalAmount
                  )}`;
                  document.getElementById(
                    "insuranceAmount"
                  ).innerHTML = `Insurance: ${
                    billingInfo.insuranceAmount < 0
                      ? 0
                      : this.toCurrencyValue(billingInfo.insuranceAmount)
                  }`;
                  document.getElementById(
                    "clientAmount"
                  ).innerHTML = `Client: ${this.toCurrencyValue(
                    billingInfo.clientAmount
                  )}`;
                } else {
                  if (element) element.style.display = "none";
                }

                this.oldStatusId = select.value;

                const scheduleEvent = await scheduleEventServer.get(
                  scheduleEventId
                );

                const tooltipItemServices = document.getElementById(
                  "tooltip-item-services"
                );
                if (tooltipItemServices) {
                  tooltipItemServices.innerHTML = this.getToolTipServices(
                    scheduleEvent
                  );
                }

                const tooltipItemDocuments = document.getElementById(
                  "tooltip-item-documents"
                );

                if (tooltipItemDocuments) {
                  tooltipItemDocuments.innerHTML = this.getToolTipDocuments(
                    scheduleEvent
                  );
                  this.linkAttachForm();
                  this.linkForms(e);
                }
                this.fetchScheduleEvents();
              };
            });
          }

          const button = el.querySelector("button.btn-checkedin-portal");
          if (button) {
            button.onclick = async () => {
              const participantId = button.dataset.id;
              const checkedIn = button.dataset.checkedin === "true";
              button.innerHTML = checkedIn
                ? button.innerHTML.replace(/Out/g, "In")
                : button.innerHTML.replace(/In/g, "Out");
              button.classList.toggle("btn-success");
              button.classList.toggle("btn-outline-success");
              await scheduleEventServer.setCheckedIn(participantId, {
                checkedIn: !checkedIn
              });
              button.dataset.checkedin = `${!checkedIn}`;
              this.fetchScheduleEvents();
            };
          }

          const attachLink = el.querySelector("#attach-document");
          if (attachLink) {
            attachLink.onclick = async () => {
              this.selectedForm = null;
              this.selectedDocuments = [];
              this.$dialog
                .alert(
                  {
                    title: "Attach document to appointment"
                  },
                  {
                    view: "radio-buttons",
                    options: [
                      { value: "existing", label: "Existing document" },
                      { value: "new", label: "New document" }
                    ],
                    defaultValue: "existing"
                  }
                )
                .then(dialog => {
                  this.selectedScheduleEventId = attachLink.dataset.eventId;
                  if (dialog.data === "existing") {
                    this.eocId = attachLink.dataset.eocId;
                    this.fetchDocsByEOC();
                    this.showSubmitDocument = true;
                  } else {
                    this.showSubmitForm = true;
                  }
                });
            };
          }

          const resendLink = el.querySelector("#resend-invitation");
          if (resendLink) {
            resendLink.onclick = async () => {
              this.confirmResend(
                resendLink.dataset.patientFirstname,
                resendLink.dataset.patientLastname,
                resendLink.dataset.eventId,
                resendLink.dataset.eocId
              );
            };
          }

          const createInvoiceLink = el.querySelector("#create-client-invoice");
          if (createInvoiceLink) {
            createInvoiceLink.onclick = () => {
              this.newInvoiceModal = {
                show: true,
                id: null,
                episodeOfCareId: createInvoiceLink.dataset.eocId,
                encounterIds: [createInvoiceLink.dataset.encounterId]
              };
            };
          }

          const showInvoiceLinks = el.querySelectorAll(
            "[id^='show-client-invoice_']"
          );
          showInvoiceLinks.forEach(showInvoiceLink => {
            showInvoiceLink.onclick = () => {
              this.invoiceViewModal = {
                show: true,
                id: showInvoiceLink.dataset.invoiceId
              };
            };
          });
          const buttonLinkCopy = el.querySelector("#copyButtonLink");
          if (buttonLinkCopy) {
            buttonLinkCopy.onclick = async () => {
              await navigator.clipboard.writeText(
                buttonLinkCopy.dataset.eventLink
              );
              this.showAlertSuccess({ message: "Link Copied" });
            };
          }

          const forms = el.querySelectorAll("a[data-appointment-form]");

          forms.forEach(node => {
            const metadata = JSON.parse(node.dataset.appointmentForm);
            var deleteImg = node.nextElementSibling;
            if (
              this.hasCurrentUserDocumentPermission(
                metadata.formId,
                "hasEntryAccess"
              )
            )
              deleteImg.onclick = () => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to remove this document?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(() => {
                    scheduleEventServer.deleteForm(metadata.id).then(() => {
                      node.parentNode.remove();
                      this.fetchData();
                    });
                  })
                  .catch(() => null);
              };

            node.onclick = async e => {
              e.preventDefault();
              const scheduleEvent = this.appointments.find(
                u => u.id == metadata.eventId
              );
              const participant = scheduleEvent.episodesOfCare[0];
              const eoc = participant.episodeOfCare;
              if (!metadata.document) {
                this.form = await this.getFormBuilderFormById(metadata.formId);
                if (
                  getFormBuilderComponents(this.form.current.content).length > 0
                ) {
                  this.openDocumentAddEdit(
                    eoc.id,
                    eoc.patient.id,
                    metadata.formId,
                    metadata.eventId,
                    participant.id,
                    scheduleEvent.startDateTime
                  );
                } else {
                  this.openDocumentFileAddEdit(
                    eoc.id,
                    eoc.patient.id,
                    metadata.formId,
                    metadata.eventId,
                    participant.id,
                    scheduleEvent.startDateTime
                  );
                }
              } else {
                this.openDocumentViewer(metadata.document);
              }
            };
          });

          const groupParticipants = el.querySelectorAll(
            "a[data-group-participant]"
          );
          groupParticipants.forEach(node => {
            const metadata = JSON.parse(node.dataset.groupParticipant);
            const participant = this.scheduleEvent.episodesOfCare.find(
              u => u.id == metadata.participantId
            );
            node.onclick = e => {
              e.preventDefault();
              this.participantNotesEditor.scheduleEvent = this.scheduleEvent;
              this.participantNotesEditor.participant = participant;
              this.participantNotesEditor.show = true;
            };
          });

          const groupParticipantsResendInvitation = el.querySelectorAll(
            "a[data-group-participant-resend-invitation]"
          );
          groupParticipantsResendInvitation.forEach(node => {
            const metadata = JSON.parse(
              node.dataset.groupParticipantResendInvitation
            );
            const scheduleEvent = this.scheduleEvents.find(
              u => u.id == metadata.eventId
            );
            const participant = scheduleEvent.episodesOfCare.find(
              u => u.id == metadata.participantId
            );

            node.onclick = e => {
              e.preventDefault();
              this.confirmResend(
                participant.episodeOfCare.patient.firstName,
                participant.episodeOfCare.patient.lastName,
                scheduleEvent.id,
                participant.episodeOfCare.id
              );
            };
          });

          // const selects = el.querySelectorAll("select.status-select");
          // if (selects && selects.length) {
          //   selects.forEach(select => {
          //     select.onchange = async e => {
          //       const participantId = select.dataset.id;
          //       const statusId = e.target.value;
          //       const status = this.statuses.find(u => u.value == statusId)
          //         .data;
          //       select.style.color = status.color;
          //       select.style.backgroundColor = status.backgroundColor;
          //       await scheduleEventServer.setStatus(participantId, {
          //         statusId
          //       });
          //       this.fetchScheduleEvents();
          //     };
          //   });
          // }

          // const groupParticipants = el.querySelectorAll(
          //   "a[data-group-participant]"
          // );
          // groupParticipants.forEach(node => {
          //   const metadata = JSON.parse(node.dataset.groupParticipant);
          //   const scheduleEvent = this.scheduleEvents.find(
          //     u => u.id == metadata.eventId
          //   );
          //   const participant = scheduleEvent.episodesOfCare.find(
          //     u => u.id == metadata.participantId
          //   );
          //   node.onclick = e => {
          //     e.preventDefault();
          //     this.editParticipantDocuments = {
          //       scheduleEvent,
          //       participant
          //     };
          //     this.showAddEditParticipantDocuments = true;
          //   };
          // });
        },
        renderer: async data => {
          let eventData = data.eventRecord.data.eventData;
          let chargedEncounter = eventData.chargedEncounter;
          if (chargedEncounter === undefined) {
            const result = await scheduleEventServer.get(
              eventData.id,
            );
            chargedEncounter = result.billingInfo?.encounterSubmited;
          }

          if (!eventData.formId) {
            this.scheduleEvent = await scheduleEventServer.get(
              data.eventRecord.data.eventData.id,
              {
                "Hide-Loading": true
              }
            );
            eventData = this.scheduleEvent;
          }

          const sum = xs => xs.reduce((a, x) => a + x, 0);
          let insurancesData = [];
          eventData.billingInfo &&
            eventData.billingInfo?.invoices?.forEach(item => {
              insurancesData.push(`<div>
                    <a class="text-primary ml-1" href="#" id="show-client-invoice_${
                      item.id
                    }"
                    data-invoice-id='${item.id}'>Invoice #${item.refNumber}</a>
                  </div>
                  <div class="tooltip-value px-2 m-1">
                    ${this.toCurrencyValue(item.totalAmount - item.amountPaid)}
                    <span style="font-size:10px; padding: 2px 10px;" class="badge-v2 ml-2 badge-danger">Unpaid</span>
                  </div>
                  <div class="tooltip-value px-2 m-1">
                    ${this.toCurrencyValue(item.amountPaid)}
                    <span style="font-size:10px; padding: 2px 10px;" class="badge-v2 ml-2 badge-success">Paid</span>
                  </div>
                `);
            });
          const invoicedAmount =
            eventData.billingInfo && eventData.billingInfo.invoices?.length
              ? Math.max(
                  sum(eventData.billingInfo.invoices.map(x => x.totalAmount)),
                  0
                )
              : eventData.billingInfo
              ? eventData.billingInfo.clientAmount
              : 0;
          let billingInfoFormatted = "";
          if (
            this.hasCurrentUserPermissionAccess("others", "patientBillingInfo")
          )
            billingInfoFormatted = `
            <div class="tooltip-item" id="billing" style="display: ${
              eventData?.billingInfo ? "block" : "none"
            };">
              <div>
                <i class="b-fa b-fa-dollar-sign"></i> Billing
              </div>
              <div class="tooltip-value px-2 m-1" id="insuranceType">
                Billing Type: ${
                  eventData.billingInfo?.insuranceType == 1
                    ? "Insurance"
                    : "Self-Pay"
                }
              </div>
              <div class="tooltip-value px-2 m-1" id="totalAmount">
                Fee: ${this.toCurrencyValue(
                  eventData.billingInfo?.totalAmount ?? 0
                )}
              </div>
              <div class="tooltip-value px-2 m-1" id="insuranceAmount">
                Insurance: ${this.toCurrencyValue(
                  Math.max(
                    eventData.billingInfo?.totalAmount - invoicedAmount,
                    0
                  )
                )}
              </div>
              <div class="tooltip-value px-2 m-1" id="clientAmount">
                Client: ${
                  eventData.billingInfo?.clientAmount
                    ? this.toCurrencyValue(eventData.billingInfo?.clientAmount)
                    : 0
                }
              </div>
              ${insurancesData.length > 0 ? insurancesData.join("\n") : ""}
                  ${
                    eventData.billingInfo?.clientAmount > 0 &&
                    eventData.billingInfo?.uninvoicedAmount > 0
                      ? `<div>
                    <a class="text-primary ml-1" href="#" id="create-client-invoice"
                    data-encounter-id='${
                      eventData.billingInfo?.encounterId
                    }' data-eoc-id='${
                          eventData.episodesOfCare.length > 0
                            ? eventData.episodesOfCare[0].episodeOfCare.id
                            : null
                        }'>+ Create client invoice</a>
                  </div>`
                      : ``
                  }
            </div>
            `;

          if (eventData.type.code == "appointment") {
            this.hasAppointmentRelated = true;
            this.editDocument.scheduleEventId = eventData.scheduleEventId;
            const participant = eventData.episodesOfCare[0];
            return `
            <div class="schedule-event-tooltip-data"></div>
            <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
              ${this.statusDropdownRenderer(
                eventData.episodesOfCare[0],
                chargedEncounter
              )}
              ${this.checkButtonRenderer(
                eventData.episodesOfCare[0],
                chargedEncounter
              )}
            </div>
            ${
              !this.selectedLocation
                ? `<div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-building"></i> Location
              </div>
              <div
                class="tooltip-value px-2 ml-1"
                style="white-space: nowrap;"
              >
                ${eventData.location.name}
              </div>
              <div class="tooltip-value px-2 ml-1">
                ${eventData.location.timeZoneDisplayName}
                </i>
              </div>
            </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>
            ${
              eventData.users
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-user"></i> Provider
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${
                        eventData.users[0]
                          ? this.formatUser(eventData.users[0])
                          : "No provider selected"
                      }
                    </div>
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Patient
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatEocObj(participant.episodeOfCare)}
              </div>

            </div>
            ${this.getBadgesAndAlertTooltip(participant)}
            ${
              eventData.placeOfService
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Place of service
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.placeOfService.code}-${eventData.placeOfService.name}`}
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.room
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Room
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.room.name}`}
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.reason
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-sticky-note"></i> Reason
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${eventData.reason}
                    </div>
                  </div>`
                : ""
            }
            <div>
            <a class="text-primary ml-1" href="#" id="resend-invitation" data-event-id='${
              eventData.id
            }'data-eoc-id='${
              participant.episodeOfCare.id
            }'data-patient-firstname='${
              participant.episodeOfCare.patient.firstName
            }'
            data-patient-lastname='${
              participant.episodeOfCare.patient.lastName
            }'
            >Resend invitation to client.</a>
            </div>
            ${
              eventData.zoomMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/zoom_icon.png")}" width="16" height="16" />
                      <span> Join Zoom Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.zoomMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.zoomMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.googleMeetMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/google_icon.png")}" width="16" height="16" />
                      <span> Join Google Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                  eventData.googleMeetMeetingUrl
                }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                  eventData.googleMeetMeetingUrl
                }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.teamsStatus == 2
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <small> The Teams meeting link will be generated 30 days before the start date.</span>
                    </div>
                  </div>`
                : ""
            }
             ${
               eventData.teamsMeetingUrl
                 ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <span> Join Teams Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.teamsMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.teamsMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                 : ""
             }
            <div id="tooltip-item-services">
            ${this.getToolTipServices(eventData)}
            </div>
            <div id="tooltip-item-documents">
            ${this.getToolTipDocuments(eventData)}
            </div> 
            ${billingInfoFormatted}
            `;
          }

          if (eventData.type.code == "groupSession") {
            const formatParticipant = p => {
              const metadata = JSON.stringify({
                eventId: eventData.id,
                participantId: p.id
              });

              const dataAttributes = `data-group-participant='${metadata}'`;
              const dataAttributesResendInvitation = `data-group-participant-resend-invitation='${metadata}'`;

              return `
              <div class="border rounded mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  ${
                    p.linkedDocuments && p.linkedDocuments.length
                      ? `<div>
                        <a href="#" class="text-primary text-underline ml-2" ${dataAttributes}>
                          <i class="fa fa-file ${
                            p.documentationCompleted
                              ? "text-success"
                              : "text-danger"
                          }"></i> ${this.formatEocObj(p.episodeOfCare)}
                        </a>
                        <br/>
                        <a href="#" class="text-primary text-underline ml-2" ${dataAttributesResendInvitation}>
                          Resend invitation to client.
                        </a>
                        </div>
                        `
                      : `<span class="ml-2">
                          ${this.formatEocObj(p.episodeOfCare)}
                        </span>`
                  }
                  <div style="width: 100px">
                    ${this.statusDropdownRenderer(
                      p,
                      eventData.billingInfo?.encounterSubmited
                    )}
                  </div>
                </div>
              </div>
              `;
            };

            return `
            <div class="schedule-event-tooltip-data"></div>
             ${
               !this.selectedLocation
                 ? `<div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-building"></i> Location
              </div>
              <div
                class="tooltip-value px-2 ml-1"
                style="white-space: nowrap;"
              >
                ${eventData.location.name}
              </div>
              <div class="tooltip-value px-2 ml-1">
                ${eventData.location.timeZoneDisplayName}
                </i>
              </div>
            </div>`
                 : ""
             }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Provider
              </div>
              <div class="tooltip-value px-2 m-1">
                ${
                  eventData.users[0]
                    ? this.formatUser(eventData.users[0])
                    : "No provider selected"
                }
              </div>
            </div>
            ${
              eventData.placeOfService
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Place of service
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.placeOfService.code}-${eventData.placeOfService.name}`}
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.room
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Room
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.room.name}`}
                    </div>
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="fas fa-align-left"></i> Topic
              </div>
              <div class="tooltip-value px-2 m-1">
                ${eventData.topic.type}
              </div>
            </div>
            ${
              eventData.services && eventData.services.length
                ? `<div class="tooltip-item">
                    <div>
                      <i class="fas fa-stethoscope"></i> Services
                    </div>
                    ${eventData.services
                      .map(service => {
                        return `
                      <div class="tooltip-value px-2 m-1">
                        ${service.service.name}
                      </div>`;
                      })
                      .join("")}
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Facilitators
              </div>
              <div class="tooltip-value px-2 m-1">
                ${
                  eventData.facilitators.length
                    ? eventData.facilitators
                        .map(facilitator => {
                          return `
                      <div class="tooltip-value m-1">
                        ${this.formatUser(facilitator.user)}
                      </div>`;
                        })
                        .join("")
                    : "No facilitator selected"
                }
              </div>
            </div>
            <div class="tooltip-item">
              <div class="d-flex justify-content-between">
                <span><i class="b-fa b-fa-user"></i> Participants</span>
                <small><i>*Click on a patient to open their documents</i></small>
              </div>
              <div class="tooltip-value m-1">
                ${eventData.episodesOfCare
                  .sort((a, b) =>
                    a.episodeOfCare.patient.firstName.localeCompare(
                      b.episodeOfCare.patient.firstName
                    )
                  )
                  .map(formatParticipant)
                  .join("")}
              </div>
            </div>
            ${
              eventData.zoomMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/zoom_icon.png")}" width="16" height="16" />
                      <span> Join Zoom Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.zoomMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.zoomMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.teamsStatus == 2
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <small> The Teams meeting link will be generated 30 days before the start date.</small>
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.teamsMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <span> Join Teams Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.teamsMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.teamsMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            `;
          }

          if (eventData.type.code == "document") {
            return `<div>
               <div class="d-flex justify-content-between align-items-center">
                  <div><span class="badge badge-primary">Document</span></div>
                  <span class="badge text-white badge-${
                    data.eventRecord.data.eventData.status == "Completed"
                      ? "success"
                      : data.eventRecord.data.eventData.status == "Pending"
                      ? "warning"
                      : "danger"
                  }">
                  ${data.eventRecord.data.eventData.status}
                  </span>
               </div>
               <div class="tooltip-item">
                  <div><i class="b-fa b-fa-clock"></i> Date Time</div>
                  <div class="tooltip-value px-2 m-1">
                  ${formatDate(data.eventRecord.data.eventData.effectiveDate)}
                  </div>
               </div>
              </div>
           </div>`;
          }
        },
        tools: {
          edit: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-edit m-0 p-0"
              : "custom-icon custom-icon-edit-prod m-0 p-0"
          },
          delete: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-delete m-0 p-0"
              : "custom-icon custom-icon-delete-prod m-0 p-0"
          },
          close: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-close m-0 p-0"
              : "custom-icon custom-icon-close-prod m-0 p-0"
          }
        },
        header: {
          titleAlign: "start"
        },
        hideDelay: false
      },
      showAddEditGroup: false,
      showAddEditAppointment: false,
      editGroupId: null,
      editAppointmentId: null,
      showAddEditParticipantDocuments: false,
      showAddDocumentEditor: false,
      showAddFileDocumentEditor: false,
      editDocument: {
        submitId: null,
        formId: null,
        clientId: null,
        eocId: null,
        hasAppointmentRelated: false
      },
      editFileDocument: {
        formId: null,
        clientId: null,
        eocId: null,
        scheduleEventId: null,
        submitId: null
      },

      settedLOC: {},
      showEocCares: false,
      showAddPlaceClientEditor: false,
      urs: [],
      showAddAutofill: false,
      autofillUrId: null,
      eocDiagnosisCodes: []
    };
  },
  mounted() {
    const currentAdjustedDateTime = this.getCurrentAdjustedDateTime();
    this.selectedMonth = currentAdjustedDateTime.getMonth();
    this.selectedYear = currentAdjustedDateTime.getFullYear();
    this.date = formatDateOnlyMysql(currentAdjustedDateTime);

    document.addEventListener("click", () => {
      this.hideLOCLists();
    });

    this.fetchLevelsOfCare("name");
    this.fetchScheduleEventStatuses();
    this.fecthDiagnosisCodes();
  },
  methods: {
    ...mapActions("client", [
      "fetchLevelsOfCare",
      "fetchScheduleEventStatuses"
    ]),
    ...mapActions("layout", ["showAlertSuccess", "showAlertError"]),
    ...mapMutations("client", ["dispatchListener"]),
    setDate() {
      //this.date = formatDateOnlyMysql(event.date);
    },
    dateRangeChange(event) {
      this.filter.startDate = formatDateOnlyMysql(event.new.startDate);
      this.filter.endDate = formatDateOnlyMysql(event.new.endDate);
      if (this.showing) this.fetchData();
    },
    cleanSelectedDocuments() {
      this.selectedDocuments = [];
      this.$refs["documentPicker"].clear();
    },
    openDocumentViewer(doc) {
      if (doc.mode == "File") {
        const url = formSubmitterServer.viewUrl(doc.id);
        window.open(url, "_blank");
      } else {
        this.documentViewModal.id = doc.id;
        this.documentViewModal.show = true;
      }
    },
    onModifydocumentViewer() {
      this.documentViewModal.show = false;
      this.fetchData();
    },
    showInvoicePaymentModal(data) {
      this.paymentAddModal.invoiceId = data.id;
      this.paymentAddModal.patient = {
        patientId: data.episodeOfCare.patientId,
        name: this.formatClient(
          data.episodeOfCare.patient.firstName,
          data.episodeOfCare.patient.middleName,
          data.episodeOfCare.patient.preferredName ?? "",
          data.episodeOfCare.patient.lastName
        )
      };
      this.paymentAddModal.show = true;
    },
    activeItemChange(event) {
      const prevFilter = { ...this.filter };
      this.filter.startDate = formatDateOnlyMysql(event.activeItem.startDate);
      this.filter.endDate = formatDateOnlyMysql(event.activeItem.endDate);
      if (
        this.filter.startDate != prevFilter.startDate ||
        this.filter.endDate != prevFilter.endDate
      )
        this.fetchData();
    },
    async eventClick(event) {
      let scheduleEvent =
        event.eventRecord.data.eventData.type.code == "groupSession" ||
        event.eventRecord.data.eventData.type.code == "appointment"
          ? await scheduleEventServer.get(event.eventRecord.data.eventData.id, {
              "Hide-Loading": true
            })
          : null;
      const encounterSubmited = scheduleEvent?.billingInfo?.encounterSubmited;
      const floatRoot = document.querySelectorAll(`.b-float-root`);
      if (floatRoot.length > 0) {
        if (event.eventRecord.data.eventData.type.code == "groupSession") {
          removeClass(floatRoot[0], "hide-sibling-notes");
          addClass(floatRoot[0], "hide-sibling-view");
          if (encounterSubmited && !this.canEditChargedEvents) {
            addClass(floatRoot[0], "hide-sibling-edit");
            addClass(floatRoot[0], "hide-sibling-delete");
          } else {
            removeClass(floatRoot[0], "hide-sibling-edit");
            removeClass(floatRoot[0], "hide-sibling-delete");
          }
        } else {
          addClass(floatRoot[0], "hide-sibling-notes");
          removeClass(floatRoot[0], "hide-sibling-view");
        }
        if (event.eventRecord.data.eventData.type.code == "appointment") {
          if (encounterSubmited && !this.canEditChargedEvents) {
            addClass(floatRoot[0], "hide-sibling-edit");
            addClass(floatRoot[0], "hide-sibling-delete");
          } else {
            removeClass(floatRoot[0], "hide-sibling-edit");
            removeClass(floatRoot[0], "hide-sibling-delete");
          }
          this.hasAppointmentRelated = true;
        }
      }
    },
    beforeEventEdit(event) {
      const eventType = event.eventRecord.data.eventData.type.code;
      const encounterSubmited = this.scheduleEvent.billingInfo?.encounterSubmited;
      const canEditEvent = !encounterSubmited || this.canEditChargedEvents; 
      if (eventType == "appointment" && canEditEvent) {
        this.editAppointmentId = event.eventRecord.data.eventData?.id;
        this.showAddEditAppointment = true;
      }
      if (eventType == "groupSession" && canEditEvent) {
        this.editGroupId = event.eventRecord.data.eventData.id;
        this.showAddEditGroup = true;
      }
      if (eventType == "document") {
        this.editDocument = {
          submitId: event.eventRecord.data.eventData.id,
          clientId: event.eventRecord.data.eventData.patientId,
          eocId: event.eventRecord.data.eventData.episodeOfCareId,
          formId: event.eventRecord.data.eventData.formId
        };
        this.showAddDocumentEditor = true;
      }
      return false;
    },
    beforeEventDelete(event) {
      this.$dialog
        .confirm(
          {
            title: `Are you sure you want to delete this ${
              event.eventRecords[0].eventData.type.code === "document"
                ? `document`
                : event.eventRecords[0].eventData.type.code === "groupSession"
                ? `group session`
                : `appointment`
            }?`
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          if (
            event.eventRecords[0].data.eventData.type.code == "groupSession"
          ) {
            let result = await scheduleEventServer.delete(
              event.eventRecords[0].data.eventData.id
            );
            if (result.errorCode) {
              this.$dialog.alert("Error: " + result.message);
            } else {
              this.fetchScheduleEvents();
              this.showAlertSuccess();
            }
          }
          if (event.eventRecords[0].data.eventData.type.code == "appointment") {
            let result = await scheduleEventServer.delete(
              event.eventRecords[0].data.eventData.id
            );
            if (result.errorCode) {
              this.$dialog.alert("Error: " + result.message);
            } else {
              this.fetchScheduleEvents();
              this.showAlertSuccess();
            }
          }
          if (event.eventRecords[0].data.eventData.type.code == "document") {
            let result = await formSubmitterServer.delete(
              event.eventRecords[0].data.eventData.id
            );
            if (result.errorCode) {
              this.$dialog.alert(
                {
                  title: "Cannot delete a completed document"
                },
                {
                  view: "error"
                }
              );
            } else {
              this.fetchDocuments();
              this.showAlertSuccess();
            }
          }
        })
        .catch(function() {});
      return false;
    },
    async deleteEocCare(eocCareId) {
      let result = await scheduleEventServer.delete(eocCareId);
      if (result.errorCode) {
        this.$dialog.alert("Error: " + result.message);
      } else {
        this.fetchEocCares();
        this.fetchURs();
        this.showAlertSuccess();
        this.dispatchFetchEoc();
      }
      return false;
    },
    fetchData() {
      this.fetchScheduleEvents();
      this.fetchDocuments();
      this.fetchEocCares();
      this.fetchURs();
    },
    async fecthDiagnosisCodes() {
      this.eocDiagnosisCodes = await diagnosisCodeServer.query(
        false,
        this.eocId
      );
    },
    async fetchScheduleEvents() {
      this.allEvents = await scheduleEventServer.query({
        startDateFrom: formatStartDateSql(this.filter.startDate),
        startDateTo: formatEndDateSql(this.filter.endDate),
        episodeOfCareIds: [this.eocId],
        types: ["GroupSession", "Appointment"]
      });

      this.scheduleEvents = this.allEvents.filter(
        event => event.type.code === "groupSession"
      );

      this.appointments = this.allEvents.filter(
        event => event.type.code == "appointment"
      );

      this.recalculateRowHeight();
    },
    async fetchDocuments() {
      const result = await documentServer.findByDateRange(this.eocId, {
        effectiveFromDate: formatStartDateSql(this.filter.startDate),
        effectiveToDate: formatEndDateSql(this.filter.endDate)
      });
      this.documentsList = result;
      this.recalculateRowHeight();
    },
    async fetchEocCares() {
      const result = await scheduleEventServer.query({
        episodeOfCareIds: [this.eocId],
        types: ["LOC"]
      });
      const newSettedLOC = {};
      for (let index = 0; index < result.length; index++) {
        const eocCare = result[index];
        const levelOfCare =
          eocCare.services.length > 0 ? eocCare.services[0].service : null;
        if (levelOfCare) {
          newSettedLOC[formatDateOnlyMysql(eocCare.startDateTime)] = {
            value: levelOfCare.id,
            label: levelOfCare.name,
            data: {
              ...levelOfCare,
              chargedEncounter: eocCare.chargedEncounter
            },
            eocCareId: eocCare.id
          };
        }
      }
      this.settedLOC = newSettedLOC;
      this.recalculateRowHeight();
    },
    openDocumentAddEdit(
      eocId,
      patientId,
      formId,
      scheduleEventId,
      scheduleEventParticipantId,
      startDateTime
    ) {
      this.editDocument.eocId = eocId;
      this.editDocument.clientId = patientId;
      this.editDocument.formId = formId;
      this.editDocument.submitId = null;
      this.editDocument.scheduleEventId = scheduleEventId;
      this.editDocument.scheduleEventParticipantId = scheduleEventParticipantId;
      this.editDocument.effectiveDateTime = startDateTime;
      this.showAddDocumentEditor = true;
    },
    openDocumentFileAddEdit(eocId, patientId, formId, scheduleEventId) {
      this.editFileDocument.eocId = eocId;
      this.editFileDocument.clientId = patientId;
      this.editFileDocument.formId = formId;
      this.editFileDocument.submitId = null;
      this.editFileDocument.scheduleEventId = scheduleEventId;
      this.showAddFileDocumentEditor = true;
    },
    confirmResend(firstName, lastName, eventId, eocId) {
      this.$dialog
        .confirm(
          {
            title: `Are you sure you want to resend the invitation for patient ${firstName} ${lastName}?`
          },
          {
            view: "multiple-actions",
            options: [
              { value: true, label: "Yes" },
              { value: false, label: "No" }
            ]
          }
        )
        .then(async value => {
          if (value.data.value) {
            this.selectedScheduleEventId = eventId;
            this.eocId = eocId;
            this.resendInvitation();
          }
        });
    },
    async resendInvitation() {
      await scheduleEventServer.resendInvitation(
        this.selectedScheduleEventId,
        this.eocId
      );
    },
    async fetchDocsByEOC(search, page, stackResult) {
      this.clientSearchChanged = true;
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      this.lastTimeout = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          this.attachDocPagination.page = 0;
          const optionsResult = await documentServer.queryImproved(
            {
              searchPhrase: search,
              episodeOfCareId: [this.eocId],
              formId: [],
              status: [],
              fromDate: null,
              toDate: null,
              effectiveFromDate: null,
              effectiveToDate: null,
              createdBy: [],
              page: page,
              pageSize: this.attachDocPagination.pageSize,
              orderBy: "creationDate",
              orderByDescending: true,
              category: [],
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : []
            },
            {
              "Hide-Loading": true
            }
          );
          this.attachDocPagination.count = optionsResult.count
            ? optionsResult.count
            : 0;
          this.attachDocPagination.page = page ? page : 0;
          this.isLastPage();
          if (stackResult) {
            let newValues = optionsResult.documents.map(doc => ({
              value: doc.id,
              label: `Ref# ${doc.documentRefNumber} | ${doc.form.name}`,
              data: doc
            }));
            this.documentsByEoc = this.documentsByEoc.concat(newValues);
          } else {
            this.documentsByEoc = optionsResult.documents.map(doc => ({
              value: doc.id,
              label: `Ref# ${doc.documentRefNumber} | ${doc.form.name}`,
              data: doc
            }));
          }
          this.clientSearchChanged = false;
        } else {
          this.clientSearchChanged = false;
          this.clientOptions = [];
        }
      }, 1000);
    },
    async fetchURs() {
      const result = await urRecordServer.query({
        page: 0,
        size: 1000000,
        orderBy: "creationDate",
        orderByDescending: true,
        episodeOfCareId: [this.eocId],
        reviewTypeId: [],
        reviewDateFrom: null,
        reviewDateTo: null,
        levelOfCareId: [],
        locationId: [],
        caseManagerId: [],
        createdAtFrom: null,
        createdAtTo: null,
        createdBy: []
      });
      this.urs = result.records;
      this.recalculateRowHeight();
    },
    onModifyAddAutofill() {
      this.showAddAutofill = false;
      this.fetchData();
    },
    getEocActiveIcdCodes(dateParam) {
      const date = moment(dateParam, "YYYY-MM-DD").toDate();
      return this.eocDiagnosisCodes
        .filter(d => {
          const activeFrom =
            d.activeFrom && moment(d.activeFrom, "YYYY-MM-DD").toDate();
          const resolvedBy =
            d.resolvedBy && moment(d.resolvedBy, "YYYY-MM-DD").toDate();
          return (
            (d.status.name == "Active" || d.status.name == "Resolved") &&
            (activeFrom == null || activeFrom <= date) &&
            (resolvedBy == null || date <= resolvedBy)
          );
        })
        .map(d => d.icdCode.id);
    },
    async autoFill(levelOfCareId, assignedDates, index) {
      const status = this.statuses.find(s => s.data.code == "show");
      await scheduleEventServer.createMultiple(
        assignedDates.map(date => ({
          type: "LOC",
          episodesOfCare: [
            {
              episodeOfCareId: this.eocId,
              icdCodeIds: this.getEocActiveIcdCodes(date),
              statusId: status.value
            }
          ],
          users: [],
          allDay: true,
          startDateTime: date,
          endDateTime: null,
          services: [
            {
              serviceId: levelOfCareId,
              costPerUnit: this.levelsOfCare.find(x => x.value == levelOfCareId)
                .data.costPerUnit,
              numberOfUnits: 1
            }
          ],
          reason: "",
          scheduleZoomMeeting: false,
          modification: "ModifySingleEvent",
          placeOfServiceId: null,
          roomId: null
        }))
      );
      this.$refs.autoFillDropdown[index].hide(true);
      this.fetchEocCares();
      this.fetchURs();
      this.dispatchFetchEoc();
    },
    onModifyAddEditGroup() {
      this.showAddEditGroup = false;
      this.fetchData();
    },
    onModifyAddEditAppointment() {
      this.showAddEditAppointment = false;
      this.fetchData();
    },
    onModifyAddEditGroupSubmit() {
      this.showAddEditParticipantDocuments = false;
      this.fetchData();
    },
    onModifyAddDocument(eventData) {
      this.showAddDocumentEditor = false;
      if (eventData.refetchDocuments) this.fetchData();
    },
    onModifyFileAddEditDocument(eventData) {
      this.showAddFileDocumentEditor = false;
      if (eventData.refetchDocuments) this.fetchData();
    },
    onModifyAddPlaceClient() {
      this.showAddPlaceClientEditor = false;
      this.fetchData();
    },
    onModifyGroupNotes() {
      this.participantNotesEditor.show = false;
      this.fetchData();
    },
    onHiddenGroupNotes() {
      this.participantNotesEditor.show = false;
    },
    addPlaceClient() {
      this.showAddPlaceClientEditor = true;
    },
    isLastPage() {
      let totalPages = Math.ceil(
        this.attachDocPagination.count / this.attachDocPagination.pageSize
      );
      let result = totalPages - 1 == this.attachDocPagination.page;
      this.attachDocPagination.lastPage = result;
    },
    checkButtonRenderer(participant, chargedEncounter) {
      const buttonDataId = `data-id="${participant.id}"`;
      const buttonDataCheckedIn = `data-checkedin="${participant.checkedIn}"`;
      const buttonClass = `class="btn btn-checkedin-portal ${
        participant.checkedIn ? "btn-success" : "btn-outline-success"
      }"`;
      const innerText = participant.checkedIn ? "Check Out" : "Check In";

      return `
      <button type="button" ${
        chargedEncounter && !this.canEditChargedEvents ? `disabled` : ``
      } ${buttonDataId} ${buttonDataCheckedIn} ${buttonClass}">
        <i class="fas fa-check mr-1"></i> ${innerText}
      </button>`;
    },
    getBadgesAndAlertTooltip(participant) {
      return `
        <div class="px-2 m-1">
              <div class="tooltip-item px-2 m-1" >
                <div class="d-flex flex-row justify-content-start flex-wrap">
                  ${participant.episodeOfCare.notes
                    .map(notes => {
                      if (notes.status !== "Disabled") {
                        return `<i
                          class="alert-note-icon fas fa-exclamation-circle text-danger mr-1"
                          data-toggle="tooltip" data-placement="top" title="${notes.content}"
                        ></i>
                        <div class="tooltip-value text-danger mr-2">
                          ${notes.content}
                        </div>
                        `;
                      } else {
                        return ``;
                      }
                    })
                    .reduce((x, y) => x + y, "")}
                </div>
              </div>
                <div class="d-flex flex-row justify-content-start flex-wrap m-1">
                  ${participant.episodeOfCare.badges
                    .map(
                      badge =>
                        `
                        <div class="tooltip-item mr-2"  data-toggle="tooltip" data-placement="top" title="${badge.name}">
                          <div
                            class="badge badge-pill"
                            style="min-width: 70px; background-color: ${badge.category.color};"
                            id="badge-tooltip-view-${badge.id}"
                          >
                            <span class="h6 tooltip-value text-white">${badge.acronym}</span>
                          </div>
                        </div>
                        `
                    )
                    .reduce((x, y) => x + y, "")}
                </div>
              </div>
      `;
    },
    eventRenderer({ eventRecord }) {
      const data = eventRecord.eventData;
      let icon = "circle";
      let textClass = "text-primary";
      let body = "";

      if (data.type.code == "groupSession") {
        icon = "users";
        textClass = "text-secondary";
        body = `${formatTimeOnly(data.startDateTime)} | ${
          data.users[0].fullName
        }`;
      }
      if (data.type.code == "document") {
        icon = "file-alt";
        textClass =
          data.status == "Completed" ? "text-success" : "text-secondary";
        body = data.form.name;
      }
      if (data.type.code == "appointment") {
        icon = "user";
        textClass = "text-secondary";
        body = `${formatTimeOnly(data.startDateTime)} | ${
          data.users.length > 0
            ? data.users[0].fullName
            : `No provider selected`
        }`;
      }
      return `
      <div class="w-100 bg-white d-flex justify-content-between align-items-center px-1 ${textClass}">
        <div>
          <i class="fa fa-${icon}"></i>
          <span class="event-name-label">${body}</span>
        </div>
      </div>`;
    },
    isFormAvailableInMyLocation(id) {
      if (
        this.selectedLocation &&
        this.selectedLocation.formIds?.includes(id)
      ) {
        return true;
      }
      return false;
    },
    async attachForm() {
      const scheduleEvent = this.appointments.find(
        u => u.id == this.selectedScheduleEventId
      );
      const participant = scheduleEvent.episodesOfCare[0];
      const eoc = participant.episodeOfCare;
      if (this.selectedForm.value != null) {
        this.showAttach = true;
        if (this.selectedDocType === "standard") {
          this.openDocumentAddEdit(
            eoc.id,
            eoc.patient.id,
            this.selectedForm.value,
            this.selectedScheduleEventId,
            participant.id,
            scheduleEvent.startDateTime
          );
        } else {
          this.openDocumentFileAddEdit(
            eoc.id,
            eoc.patient.id,
            this.selectedForm.value,
            this.selectedScheduleEventId,
            participant.id,
            scheduleEvent.startDateTime
          );
        }
      } else {
        this.showAttach = false;
      }
    },
    async attachDocument() {
      await scheduleEventServer.attachDocuments(
        this.selectedScheduleEventId,
        this.selectedDocuments
      );
      this.fetchData();
    },
    hideLOCLists(except) {
      const locLists = document.getElementsByClassName("loc-list");
      for (let index2 = 0; index2 < locLists.length; index2++) {
        const locList = locLists[index2];
        if (locList != except) {
          removeClass(locList, "d-block");
          addClass(locList, "d-none");
        }
      }
    },
    paint({ firstPaint }) {
      if (firstPaint) {
        on(
          this.$el,
          "click",
          ".show-hide-loc-dropdown, .show-hide-loc-dropdown i",
          async (target, event) => {
            event.stopPropagation();
            let parent = target.parentElement;
            if (target.nodeName == "I") parent = parent.parentElement;
            for (let index = 0; index < parent.children.length; index++) {
              const child = parent.children[index];
              if (hasClass(child, "loc-list")) {
                this.hideLOCLists(child);
                if (hasClass(child, "d-none")) {
                  removeClass(child, "d-none");
                  addClass(child, "d-block");
                } else if (hasClass(child, "d-block")) {
                  removeClass(child, "d-block");
                  addClass(child, "d-none");
                }
              }
            }
          }
        );
        on(this.$el, "click", ".loc-value", async target => {
          const date = target.dataset.date;
          const locValue = target.dataset.loc;
          let chargedEncounter = false;
          if (this.settedLOC[date] != undefined) {
            const eventData = await scheduleEventServer.get(
              this.settedLOC[date]?.eocCareId,
              {
                "Hide-Loading": true
              }
            );
            chargedEncounter = eventData.billingInfo?.encounterSubmited;
          }

          if (
            chargedEncounter &&
            !this.hasCurrentUserPermissionAccess("others", "editChargedEvents")
          ) {
            await this.showAlertError({
              message:
                "Sorry, this Level of Care cannot be modified because a charge has already been submitted"
            });
            return;
          } else {
            if (locValue) {
              this.settedLOC = {
                ...this.settedLOC,
                [date]: {
                  ...this.levelsOfCare.find(loc => loc.value == locValue),
                  eocCareId: ""
                }
              };
              const status = this.statuses.find(s => s.data.code == "show");
              const levelOfCare = this.levelsOfCare.find(
                x => x.value == locValue
              ).data;
              await this.fecthDiagnosisCodes();
              await scheduleEventServer.create({
                type: "LOC",
                episodesOfCare: [
                  {
                    episodeOfCareId: this.eocId,
                    icdCodeIds: this.getEocActiveIcdCodes(date),
                    statusId: status.value
                  }
                ],
                users: [],
                allDay: true,
                startDateTime: date,
                endDateTime: null,
                services: [
                  {
                    serviceId: locValue,
                    costPerUnit: levelOfCare.costPerUnit,
                    numberOfUnits: 1,
                    billingCodes: levelOfCare.billingCodes.map(bc => ({
                      ...bc,
                      costPerUnit:
                        bc.costPerUnit != "" || null ? bc.costPerUnit : 0,
                      numberOfUnits:
                        bc.numberOfUnits != "" || null ? bc.numberOfUnits : 1,
                      scheduleEventId: this.scheduleEventId,
                      serviceId: levelOfCare.serviceId
                    })),
                    color: levelOfCare.color != null ? levelOfCare.color : null
                  }
                ],
                reason: "",
                scheduleZoomMeeting: false,
                modification: "ModifySingleEvent",
                placeOfServiceId: null,
                roomId: null
              });
            } else {
              if (this.settedLOC[date] != undefined) {
                const newSettedLOC = { ...this.settedLOC };
                await this.deleteEocCare(newSettedLOC[date].eocCareId);
                delete newSettedLOC[date];
                this.settedLOC = newSettedLOC;
              }
            }
            this.fetchEocCares();
            this.fetchURs();
            this.dispatchFetchEoc();
          }
        });
      }
    },
    recalculateRowHeight() {
      // if (this.recalculateTimeOutRef) clearTimeout(this.recalculateTimeOutRef);
      // this.recalculateTimeOutRef = setTimeout(() => {
      //   const weekRows = this.$el.querySelectorAll(
      //     ".b-weeks-container .b-calendar-row"
      //   );
      //   for (let index = 0; index < weekRows.length; index++) {
      //     const weekRow = weekRows[index];
      //     const defaultMinHeight = 100;
      //     const maxCount = this.calendarMaxDatesCountFromWeek(
      //       weekRow.dataset.week
      //     );
      //     const computedHeight = maxCount * 23 + 30;
      //     weekRow.style.flexBasis =
      //       Math.max(defaultMinHeight, computedHeight) + "px";
      //   }
      // }, 500);
    },
    calendarMaxDatesCountFromWeek(yearWeek) {
      let maxCount = 0;
      const events = this.calendarEvents;
      const dates = {};
      for (let index = 0; index < events.length; index++) {
        const event = events[index];
        const eventStartWeekDate = moment(event.startDate).startOf("week");
        const eventYearWeek = `${eventStartWeekDate
          .toDate()
          .getFullYear()},${moment(event.startDate).isoWeek()}`;
        if (eventYearWeek == yearWeek) {
          const date = formatDateOnlyMysql(event.startDate);
          if (!dates[date]) dates[date] = 0;
          dates[date] += 1;
          if (dates[date] > maxCount) maxCount = dates[date];
        }
      }
      return maxCount;
    },
    dispatchFetchEoc() {
      this.dispatchListener({ listener: "fetchEoc", param: this.eocId });
      this.dispatchListener({ listener: "fetchEoc", param: "all" });
    },
    statusDropdownRenderer(participant, chargedEncounter) {
      const currentStatus = this.statuses.find(
        u => u.value == participant.scheduleEventStatus.id
      );
      const color = currentStatus.data.color;
      const bgColor = lightenDarkenColor(color, 85);

      const selectDataId = `data-id="${participant.id}"`;
      const selectClass = `class="custom-select status-select"`;
      const selectStyle = `
        style="color: ${color};
        background-color: ${bgColor};
        font-weight: bold;
        max-width: 100%;
        width: 200px;"`;
      return `<select ${
        chargedEncounter && !this.canEditChargedEvents ? `disabled` : ``
      } ${selectDataId} ${selectClass} ${selectStyle}>
        ${this.statuses.map(
          status => `
          <option value="${status.value}"
            ${status == currentStatus ? "selected" : ""}
             style="color: ${status.data.color};
                    background-color: white;
                    font-weight: bold;">
            ${status.label}
          </option>
        `
        )}
      </select>`;
    },
    getToolTipServices(eventData) {
      return eventData.services && eventData.services.length
        ? `<div class="tooltip-item">
                    <div>
                      <i class="fas fa-stethoscope"></i> Services
                    </div>
                    ${eventData.services
                      .map(service => {
                        return `
                      <div class="tooltip-value px-2 m-1">
                        ${service.service.name}
                      </div>`;
                      })
                      .join("")}
                  </div>`
        : "";
    },
    getToolTipDocuments(eventData) {
      const participant = eventData.episodesOfCare[0];
      const formatDocument = f => {
        const metadata = JSON.stringify({
          eventId: eventData.id,
          id: f.id,
          formId: f.formId,
          document: f.document
        });

        const dataAttributes = `data-appointment-form='${metadata}'`;

        const cssClass =
          !f.document || f.document.status == "Draft"
            ? "fa fa-clock-o text-danger"
            : f.document.status == "Pending"
            ? "fa fa-clock-o text-warning"
            : "fa fa-check text-success";
        let hasEntryAccess = this.hasCurrentUserDocumentPermission(
          f.formId,
          "hasEntryAccess"
        );
        const linkClasses = hasEntryAccess
          ? "text-primary text-underline"
          : "text-secondary text-none disabled";

        const result = `<i style="font-size: 19px;" class="${cssClass}"></i>
                <a class="${linkClasses} ml-1" href="#" ${dataAttributes}>
                  ${f.form.name}
                </a>
                ${
                  hasEntryAccess
                    ? '<i style="font-size: 19px;" class="fa fa-times text-danger ml-2 hover-pointer"></i>'
                    : ""
                }
                `;

        return `<div class="d-flex w-100 justify-content-start align-items-center">${
          f.isEnabledInScheduleEventLocation || f.document
            ? result
            : `<span class='ml-4'>${f.form.name}</span>`
        }</div>`;
      };
      return `${
        participant.linkedDocuments && participant.linkedDocuments.length
          ? `
              <div class="tooltip-item">
                <div class="d-flex justify-content-between">
                  <span><i class="fas fa-file-alt"></i> Documents</span>
                </div>
                <div class="tooltip-value m-1">
                  ${participant.linkedDocuments
                    .sort((a, b) => a.form.name.localeCompare(b.form.name))
                    .map(formatDocument)
                    .join("")}
                </div>
              </div>
              `
          : ""
      }
            <div>
            <a class="text-primary ml-1" href="#" id="attach-document" data-event-id='${
              eventData.id
            }' data-eoc-id='${
        participant.episodeOfCare.id
      }'>+ Attach document</a>
            </div>`;
    },
    linkAttachForm() {
      const attachLink = document.querySelector("#attach-document");
      if (attachLink) {
        attachLink.onclick = async () => {
          this.selectedForm = null;
          this.selectedDocuments = [];
          this.$dialog
            .alert(
              {
                title: "Attach document to appointment"
              },
              {
                view: "radio-buttons",
                options: [
                  { value: "existing", label: "Existing document" },
                  { value: "new", label: "New document" }
                ],
                defaultValue: "existing"
              }
            )
            .then(dialog => {
              this.selectedScheduleEventId = attachLink.dataset.eventId;
              if (dialog.data === "existing") {
                this.eocId = attachLink.dataset.eocId;
                this.fetchDocsByEOC();
                this.showSubmitDocument = true;
              } else {
                this.showSubmitForm = true;
              }
            });
        };
      }
    },
    linkForms(e) {
      const forms = document.querySelectorAll("a[data-appointment-form]");

      forms.forEach(node => {
        const metadata = JSON.parse(node.dataset.appointmentForm);
        var deleteImg = node.nextElementSibling;
        if (
          this.hasCurrentUserDocumentPermission(
            metadata.formId,
            "hasEntryAccess"
          )
        )
          deleteImg.onclick = () => {
            this.$dialog
              .confirm(
                {
                  title: "Are you sure you want to remove this document?"
                },
                {
                  view: "confirm-delete"
                }
              )
              .then(() => {
                scheduleEventServer.deleteForm(metadata.id).then(() => {
                  node.parentNode.remove();
                  this.keepTooltip(e, async () => await this.fetchData());
                });
              })
              .catch(() => null);
          };

        node.onclick = async e => {
          e.preventDefault();
          const scheduleEvent = this.scheduleEvents.find(
            u => u.id == metadata.eventId
          );
          const participant = scheduleEvent.episodesOfCare[0];
          const eoc = participant.episodeOfCare;
          if (!metadata.document) {
            this.form = await this.getFormBuilderFormById(metadata.formId);
            if (
              getFormBuilderComponents(this.form.current.content).length > 0
            ) {
              this.openDocumentAddEdit(
                eoc.id,
                eoc.patient.id,
                metadata.formId,
                metadata.eventId,
                participant.id,
                scheduleEvent.startDateTime
              );
            } else {
              this.openDocumentFileAddEdit(
                eoc.id,
                eoc.patient.id,
                metadata.formId,
                metadata.eventId,
                participant.id,
                scheduleEvent.startDateTime
              );
            }
          } else {
            this.openDocumentViewer(metadata.document);
          }
        };
      });
    }
  },
  computed: {
    ...mapGetters("client", [
      "levelsOfCareCurrentLocation",
      "selectedLocation",
      "formsMainAndMasterTreatmentPlanCurrentLocation"
    ]),
    ...mapGetters("layout", [
      "hasCurrentUserPermissionAccess",
      "hasCurrentUserDocumentPermission",
      "canEditChargedEvents"
    ]),
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    ...mapState("client", {
      statuses: state =>
        state.scheduleEventStatuses.map(status => ({
          value: status.id,
          label: status.name,
          data: {
            ...status,
            backgroundColor: lightenDarkenColor(status.color, 85)
          }
        })),
      ...mapState("layout", {
        selectedLocation: state => state.selectedLocation
      })
    }),
    levelsOfCare() {
      let levelsOfCareCurrentLocation = [];
      if (this.selectedLocation == null) {
        levelsOfCareCurrentLocation = this.levelsOfCareCurrentLocation.filter(
          loc => this.location.serviceIds.some(y => y == loc.id)
        );
      } else {
        levelsOfCareCurrentLocation = this.levelsOfCareCurrentLocation;
      }
      return [
        {
          value: "",
          label: "Clear LOC",
          data: {},
          optionClass: "text-danger"
        },
        ...levelsOfCareCurrentLocation.map(loc => ({
          value: loc.id,
          label: loc.name,
          data: loc
        }))
      ];
    },
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ursRemaining() {
      return this.urs.filter(ur => ur.remainingUnits > 0);
    },
    formOptions() {
      const forms = this.formsMainAndMasterTreatmentPlanCurrentLocation
        .filter(form =>
          this.hasCurrentUserDocumentPermission(form.id, "hasEntryAccess")
        )
        .map(form => ({
          value: form.id,
          label: form.name
        }));

      return [...forms].sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
    },
    selectedDocumentsComputed: {
      get() {
        return this.selectedDocuments.map(d => ({
          documentId: d,
          readonly: true
        }));
      },
      set(newValue) {
        this.selectedDocuments = newValue.map(d => d.documentId);
      }
    },
    modes() {
      const defaultMinHeight = 100;
      const maxCount = this.calendarMaxDatesCount;
      const computedHeight = maxCount * 23 + 30;
      const self = this;
      return {
        ...{
          week: null,
          month: {
            ...{
              eventRenderer: this.eventRenderer,
              minRowHeight: Math.max(defaultMinHeight, computedHeight),
              showWeekColumn: false,
              showWeekNumber: false,
              disableOtherMonthCells: true,
              dayCellRenderer: function(cellData) {
                var currentDate = new Date(self.date);
                let isLastRowDate = () => {
                  if (
                    cellData.isOtherMonth &&
                    (cellData.date.getMonth() == currentDate.getMonth() + 1 ||
                      cellData.date.getFullYear() > currentDate.getFullYear())
                  ) {
                    return true;
                  }

                  let nextDate = moment(cellData.date).add(1, "day");

                  while (getWeekDay(nextDate) != 0) {
                    if (getWeekDay(nextDate) == 6) {
                      return nextDate.month() == currentDate.getMonth() + 1;
                    }
                    nextDate = nextDate.add(1, "day");
                  }
                  return false;
                };

                cellData.style = `background-color:${
                  self.settedLOC[formatDateOnlyMysql(cellData.date)]
                    ? self.settedLOC[formatDateOnlyMysql(cellData.date)].data
                        .color
                    : "white"
                }`;
                return `
                <div class="w-100 d-flex justify-content-between align-items-center">

                  <span style="font-size: 12px;" class="${
                    cellData.isOtherMonth != 0 ? "color-custom-grey" : ""
                  }">${cellData.date.getDate()}</span>
                  ${
                    self.settedLOC[formatDateOnlyMysql(cellData.date)]
                      ? `<span class="font-weight-bold ml-1" style="font-size: 11px">${
                          self.settedLOC[formatDateOnlyMysql(cellData.date)]
                            .label
                        }</span>`
                      : ``
                  }

                  <div class="position-relative d-flex">
                    <div class="show-hide-loc-dropdown d-flex justify-content-center align-items-center rounded-circle loc-option-trigger hover-pointer" style="width: 25px; height: 25px; font-size: 15px; margin-top: 5px">
                      <i class="fa fa-ellipsis-v"></i>
                    </div>
                    <div class="position-absolute loc-list d-none text-left bg-white border border-color-light-gray shadow-sm bg-white border rounded py-2" style="${
                      isLastRowDate() ? `bottom: 20px` : `top: 20px`
                    }; right: initial; z-index: 2; min-width: 100px; border-color: #cbcbcb !important; max-width: 350px; max-height: 200px; overflow: auto;">
                      ${self.levelsOfCare
                        .map(
                          loc => `
                      <div class="p-1 loc-value px-2 py-2 color-custom-dark-grey ${
                        loc.optionClass ? loc.optionClass : ""
                      }" style="font-size: 12px;" data-loc="${
                            loc.value
                          }" data-date="${formatDateOnlyMysql(
                            cellData.date
                          )}">${loc.label}</div>
                      `
                        )
                        .join("")}
                    </div>
                  </div>

                </div>
                `;
              }
            }
          },
          agenda: null,
          day: null,
          year: null
        }
      };
    },
    calendarDate() {
      return moment(this.date).toDate();
    },
    calendarMaxDatesCount() {
      let maxCount = 0;
      const events = this.calendarEvents;
      const dates = {};
      for (let index = 0; index < events.length; index++) {
        const event = events[index];
        const date = formatDateOnlyMysql(event.startDate);
        if (!dates[date]) dates[date] = 0;
        dates[date] += 1;
        if (dates[date] > maxCount) maxCount = dates[date];
      }
      return maxCount;
    },
    calendarEvents: {
      get() {
        const events = [];

        if (this.filter.types.includes("groupSessions")) {
          const groupSessions = this.scheduleEvents;
          for (let index = 0; index < groupSessions.length; index++) {
            const group = groupSessions[index];
            const startDateTime = moment(group.startDateTime).toDate();
            const endDateTime = group.endDateTime
              ? moment(group.endDateTime).toDate()
              : moment(startDateTime)
                  .endOf("day")
                  .toDate();
            events.push({
              eventData: group,
              startDate: startDateTime,
              endDate: endDateTime,
              eventColor: "#FFFFFF",
              name: `Group Session (${
                group.allDay
                  ? "All day"
                  : calculateDurationInMinutes(startDateTime, endDateTime) +
                    " min"
              })`,
              resourceId: null,
              iconCls: "no-icon"
            });
          }
        }

        if (this.filter.types.includes("appointments")) {
          const appointments = this.appointments;
          for (let index = 0; index < appointments.length; index++) {
            const appointment = appointments[index];
            const startDateTime = moment(appointment.startDateTime).toDate();
            const endDateTime = appointment.endDateTime
              ? moment(appointment.endDateTime).toDate()
              : moment(startDateTime)
                  .endOf("day")
                  .toDate();
            events.push({
              eventData: appointment,
              startDate: startDateTime,
              endDate: endDateTime,
              eventColor: "#FFFFFF",
              name: `Appointment (${
                appointment.allDay
                  ? "All day"
                  : calculateDurationInMinutes(startDateTime, endDateTime) +
                    " min"
              })`,
              resourceId: null,
              iconCls: "no-icon"
            });
          }
        }

        if (this.filter.types.includes("documents")) {
          for (let index = 0; index < this.documentsList.length; index++) {
            const document = this.documentsList[index];
            let srt = document.form.name;
            let name;
            if (srt.length >= 26) {
              name = srt.slice(0, 26) + "...";
            } else {
              name = srt;
            }
            events.push({
              eventData: { ...document, type: { code: "document" } },
              startDateTime: document.effectiveDate,
              startDate: moment(document.effectiveDate).toDate(),
              allDay: true,
              eventColor: "#FFFFFF",
              endDate: moment
                .utc(document.effectiveDate)
                .add(2, "hour")
                .toDate(),
              name: `${name} ${
                document.scheduleEventDuration
                  ? `(${document.scheduleEventDuration} min)`
                  : ``
              }`,
              resourceId: null,
              iconCls: "no-icon"
            });
          }
        }

        if (
          this.settedLOC &&
          Object.keys(this.settedLOC).length &&
          events.length === 0
        ) {
          return [{ eventData: { type: "" } }];
        }

        events.sort((e1, e2) => {
          return e1.startDateTime <= e2.startDateTime ? -1 : 1;
        });
        return this.settedLOC ? events : [];
      }
    },
    calendarResources: {
      get() {
        return [];
      }
    },
    eocCaresList() {
      const list = {};
      for (let index = 0; index < Object.keys(this.settedLOC).length; index++) {
        const date = Object.keys(this.settedLOC)[index];
        if (!list[this.settedLOC[date].value]) {
          list[this.settedLOC[date].value] = {
            loc: this.settedLOC[date].data,
            dates: []
          };
        }
        list[this.settedLOC[date].value].dates.push({
          date,
          eocCareId: this.settedLOC[date].eocCareId
        });
      }
      return Object.values(list);
    },
    imageDelete() {
      return this.isStandalone()
        ? "/icons/delete.svg"
        : "/desktop/icons/delete.svg";
    }
  },
  watch: {
    showing: function(newValue) {
      if (newValue) {
        this.fetchData();
      }
    },
    "filter.types": function() {
      this.fetchData();
    },
    scheduleEvents: function() {}
  }
};
</script>

<style scoped>
.hide-sibling-edit .custom-icon-edit {
  display: none;
}
.hide-sibling-edit .custom-icon-edit-prod {
  display: none;
}

.hide-sibling-delete .custom-icon-delete {
  display: none;
}
.hide-sibling-delete .custom-icon-delete-prod {
  display: none;
}
#calendar-view-client .calendar-content {
  padding-right: 13px;
}
#calendar-view-client >>> .b-calendarpanel .b-calendar-days {
  overflow: initial;
}
.show-eoc-cares {
  position: absolute;
  top: 53px;
  right: 0px;
  z-index: 2;
  box-shadow: -5px 5px 5px -1px rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
.eoc-cares {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 3;
}
.eoc-cares-list {
  width: 0px;
  height: calc(100vh - 231px);
  overflow-y: auto;
  transition: width 0.5s;
}
.eoc-cares-list-show {
  width: 250px;
  overflow-x: hidden;
  box-shadow: -5px 5px 5px -1px rgba(0, 0, 0, 0.5);
}
#calendar-view-client {
  height: calc(100vh - 233px);
}
.sidebar-filters-container {
  max-height: calc(100vh - 520px);
  min-height: calc(100vh - 520px);
  overflow-y: auto;
  overflow-x: hidden;
}
.divider {
  margin: 10px 0px;
}
.form {
  text-align: center;
  padding-top: 6px;
}
.event-type-container {
  margin: 0px 10px;
}
.event-type-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;
}
.event-type-label {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.event-type-label-item {
  font-size: 13px;
}
.box-color {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.box-color-red {
  background-color: red;
}
.box-color-yellow {
  background-color: yellow;
}
.filter-container {
  float: left;
  width: 240px;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  overflow: auto;
  transition: width 0.5s;
  overflow-x: hidden;
}
.filter-container-inner {
  width: 210px;
  padding: 0px;
}
.participants-container {
  margin: 0px 10px;
}
.add-event-container {
  text-align: center;
}
.filter-label {
  font-size: 0.9rem;
  font-weight: 400;
}
.filter-container-hidden {
  width: 0px !important;
}
.main-bar {
  background-color: #0062cc;
  padding: 5px 10px;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  align-items: center;
  color: white;
}
.main-bar-left {
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
.icon-img {
  height: 40px;
  width: 40px;
}
.toggle-sidebar:hover {
  cursor: pointer;
}
.filter-icon {
  transition: transform 0.5s;
}
.filter-icon-rotate {
  transform: rotate(90deg);
}
.event-type-label-text {
  font-size: 13px;
}
.action-button {
  width: 180px;
}
.cut-text {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 74px;
  white-space: nowrap;
}
</style>
<style>
#calendar-view-client .calendar-content .b-calendar .b-monthview {
  padding-top: 0px !important;
}
#calendar-view-client
  .calendar-content
  .b-monthview
  .b-calendar-row.b-calendar-weekdays
  .b-calendar-day-header {
  font-size: 12px;
}
#calendar-view-client .calendar-content .b-monthview .b-monthview-content {
  background-color: #f5f8fc;
}
#calendar-view-client .calendar-content .b-cal-event-wrap.b-allday {
  opacity: 1 !important;
}
#calendar-view-client .calendar-content .b-top-toolbar {
  display: none;
}
#calendar-view-client
  .calendar-content
  .b-monthview
  .b-weeks-container
  .b-calendar-row
  .b-calendar-cell {
  overflow: initial !important;
}
#calendar-view-client .calendar-content .b-monthview .b-week-num {
  display: none;
}
#calendar-view-client
  .calendar-content
  .b-monthview
  .b-cal-cell-header
  .b-day-name {
  overflow: initial !important;
}
#calendar-view-client
  .calendar-content
  .b-cal-event-bar-container
  .b-cal-event {
  padding: 0px !important;
}
#calendar-view-client .calendar-content .b-cal-event-body {
  padding: 0px !important;
  width: 100%;
}
#calendar-view-client .calendar-content .event-name-label {
  font-size: 12px;
}
#calendar-view-client .calendar-content .b-day-name {
  width: 100%;
}
#calendar-view-client
  .b-calendar-week
  .b-calendar-days
  .b-calendar-cell:nth-child(n + 4)
  .loc-list {
  right: 0px !important;
}
.container-calendar-client .vs__dropdown-menu {
  max-height: 150px !important;
}
.container-calendar-client .items-list-container {
  max-height: 165px !important;
}
.hide-sibling-notes .custom-icon-notes {
  display: none;
}
.hide-sibling-view .custom-icon-view {
  display: none;
}
.color-box {
  background-color: red;
  color: white;
  padding: 2px;
  border-radius: 35px;
  min-width: 24px;
  min-height: 24px;
  margin-right: 5px;
  text-align: center;
}
.custom-control-inline {
  margin-right: 0px !important;
}
.b-sch-event {
  flex-wrap: wrap;
  align-content: flex-start;
}
.b-panel-header.b-dock-top {
  border-bottom: none;
}
.b-popup-header {
  background-color: #f6f6f6;
}
.b-panel-header .b-header-title {
  font-size: 16px;
}
.b-panel-header {
  padding: 5px 10px;
}
.b-tooltip-content {
  padding: 5px 10px;
}
.b-popup.b-sch-event-tooltip {
  max-width: 20rem;
  min-width: 20rem;
  margin: 0px;
}
.tooltip-participants-container {
  background-color: #f6f6f6;
  margin: 0px !important;
}
.tooltip-participants-container .col-sm-6 {
  padding: 0px 5px !important;
}
.grey-circle {
  min-width: 10px;
  min-height: 10px;
  background-color: #d0d0d0;
  margin-right: 5px;
  border-radius: 10px;
  margin-top: 5px;
}
.participant-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.tooltip-value {
  font-size: 14px;
}
.tooltip-value-right {
  align-self: right;
}
.tooltip-item {
  margin-top: 10px;
}
.tooltip-footer {
  text-align: center;
}
.tooltip-item-calendar {
  display: none;
}
.copy-link-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.b-grid-header-text {
  font-size: 14.4px;
}
#calendar-view-client .b-grid-header-resizable {
  background-color: #0062cc;
  color: white;
  align-items: center;
}
#calendar-view-client .b-grid-header-resizable:hover {
  background-color: #0062cc !important;
}
.vs__deselect {
  margin-left: 5px !important;
}
#calendar-view-client .b-calendar {
  display: initial !important;
}
#calendar-view-client .b-sidebar {
  display: initial !important;
  position: initial !important;
  width: initial !important;
}
#calendar-view-client .b-calendar .b-calendar-content {
  height: calc(100vh - 235px) !important;
}
#calendar-view-client .b-float-root {
  z-index: 10 !important;
}
#calendar-view-client .b-calendar .b-calendar-inner .font-weight-bold {
  font-weight: 400 !important;
  font-size: 15px;
}
#calendar-view-client .b-calendar .b-calendar-inner .text-muted {
  color: #d8d8d8 !important;
}

#calendar-view-client .b-calendar-nav {
  position: relative;
}
#calendar-view-client .b-calendar-nav button {
  display: none !important;
}
#calendar-view-client .b-calendar-nav button:nth-child(2) {
  display: block !important;
  flex: none !important;
  position: absolute;
  right: 30px;
  top: 5px;
}
#calendar-view-client .b-calendar-nav button:nth-child(4) {
  display: block !important;
  flex: none !important;
  position: absolute;
  right: 0px;
  top: 5px;
}
#calendar-view-client .b-calendar-grid-weekdays.border-bottom {
  border-bottom: none !important;
}

#calendar-view-client .b-calendar .b-calendar-inner .font-weight-bold {
  font-weight: 400 !important;
}
#calendar-view-client .b-calendar .b-calendar-inner .text-muted {
  color: #d8d8d8 !important;
}
#calendar-view-client .b-calendar-grid-help {
  display: none;
}
#calendar-view-client .b-calendar .b-calendar-grid {
  border: none;
}
#calendar-view-client .b-calendar .b-calendar-inner {
  min-width: 200px !important;
}
#calendar-view-client .b-calendar-grid-caption.text-center {
  text-align: left !important;
}
#calendar-view-client .b-calendar .b-calendar-grid {
  background-color: transparent !important;
}
#calendar-view-client .b-calendar > .b-top-toolbar {
  background-color: white !important;
}
#calendar-view-client label {
  margin-bottom: 0px !important;
}
#calendar-view-client .font-size-icon::before {
  font-size: 17px !important;
}
#calendar-view-client .little-badge {
  font-size: 11px;
}
#calendar-view-client {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
#calendar-view-client .b-calendar .b-calendar-grid-body .col[data-date] .btn,
#calendar-view-client .b-calendar-grid-weekdays.border-bottom small {
  font-size: 12px !important;
}
#calendar-view-client .form-group legend {
  font-size: 15px !important;
  color: #495057;
}
.small-selector {
  font-size: 13px;
}
#calendar-view-client .calendar-content .loc-option-trigger {
  font-size: 12px;
  color: #646a7a;
  margin-right: 1px;
}
#calendar-view-client .calendar-content .loc-option-trigger:hover {
  background-color: #d8d8d8;
}
#calendar-view-client .calendar-content .loc-value:hover {
  background-color: #f5f8fc;
}
#calendar-view-client
  .calendar-content
  .b-cal-event-bar-container
  .b-cal-event {
  background-color: transparent !important;
}
#calendar-view-client .calendar-content .b-cal-event-body .b-cal-event-desc {
  padding: 0px 2px;
}
#calendar-view-client .b-calendar-cell > .b-cal-cell-overflow {
  background-color: white !important;
}
#calendar-view-client .b-calendar-cell > .b-cal-cell-overflow:hover {
  color: black !important;
}
</style>
